import { Box, List, ListItem, ListItemText, Typography } from "@mui/material";
import DialogWrapper from "components/DialogWrapper";

const IncomeTaxTanStatements = (props) => {
  const { open, setOpen } = props;
  return (
    <DialogWrapper
      title="The ATOM Pro TAN Forms- Traces Statements Info"
      open={open}
      setOpen={setOpen}
      width="lg"
    >
      <Box sx={{ padding: 2, backgroundColor: "#f9f9f9", borderRadius: 2 }}>
        <Typography variant="body1" gutterBottom>
          The ATOM Pro TAN Module is designed to seamlessly retrieve TDS and TCS form filing
          information from both the Income Tax e-Filing Portal and the Traces Portal.
        </Typography>

        <Typography variant="subtitle1" gutterBottom>
          Automation Sync Capabilities:
        </Typography>
        <List>
          <ListItem sx={{ display: "list-item" }}>
            <ListItemText primary="Statements/Forms filed via the e-Filing Portal will be automatically fetched starting from the date of TAN allotment, ensuring comprehensive coverage from inception." />
          </ListItem>
          <ListItem sx={{ display: "list-item" }}>
            <ListItemText primary="Statements/Forms filed manually through Protean eGov Technologies Limited (formerly NSDL e-Governance Infrastructure Ltd) centers will be retrievable for the 3 months period immediately preceding the date on which the sync is performed within the application." />
          </ListItem>
          <ListItem sx={{ display: "list-item" }}>
            <ListItemText primary="Once data is successfully synced from the Traces Portal, it will be retained within the application, even after the three-month retrieval window has passed—ensuring continuity and historical access." />
          </ListItem>
        </List>

        <Typography variant="subtitle1" gutterBottom>
          Form Processing Status Retrieval:
        </Typography>
        <Typography variant="body1" gutterBottom>
          During the sync period, the module will also fetch the Statement Processing Status and
          Date of Processing for the following forms:
        </Typography>
        <List>
          <ListItem sx={{ display: "list-item" }}>
            <ListItemText primary="Form 24Q" />
          </ListItem>
          <ListItem sx={{ display: "list-item" }}>
            <ListItemText primary="Form 26Q" />
          </ListItem>
          <ListItem sx={{ display: "list-item" }}>
            <ListItemText primary="Form 27Q" />
          </ListItem>
          <ListItem sx={{ display: "list-item" }}>
            <ListItemText primary="Form 27EQ" />
          </ListItem>
        </List>
      </Box>
    </DialogWrapper>
  );
};

export default IncomeTaxTanStatements;
